export default __webpack_public_path__ + "static/media/direct-message-description.a24021f9.png";